import React from 'react';
import { t } from 'i18next';
import { PasswordChange } from 'templates';
import { Collapsible } from '@sentara-health/optimahealth_web';
import { ProfileInformations } from './interface';
import { DeviceTypes, useDeviceType } from 'common';


const Password = ({
    state,
    changePassword,
    setChangePassword,
    expand = true,
    onExpand,
    onCollapse,
}: {
    setState: React.Dispatch<React.SetStateAction<ProfileInformations>>;
    state: ProfileInformations;
    changePassword: boolean;
    setChangePassword: React.Dispatch<React.SetStateAction<boolean>>;
    expand?: boolean;
    onExpand?: () => void;
    onCollapse?: () => void;
}) => {

    const deviceType = useDeviceType();
    const isMobile = deviceType === DeviceTypes.MOBILE;


    return (
        <Collapsible
            title={t('common.password')}
            id={'phoneNotifications'}
            isMobile={isMobile}
            key={`${'phoneNotifications'}-${isMobile ? 'mobile' : 'desktop'}`}
            expand={expand}
            onExpand={onExpand}
            onCollapse={onCollapse}
            className="mb-3 pb-2"
        >
            <div className="set_my_preferences">
                <div className="border_wrapper">
                    <div className="user_address_wrapper">
                        <div className="row">
                            <div className="mb-2">
                                <PasswordChange
                                    state={state}
                                    changePassword={changePassword}
                                    setChangePassword={setChangePassword}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Collapsible>
    );
};


export default Password;